(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;

    if (sessionStorage.getItem('announcement-bar-dismissed')) {
      return;
    }

    bar.removeAttribute('hidden');

    var closeBtn = bar.querySelector('[data-announcement-bar-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.setAttribute('hidden', '');
        sessionStorage.setItem('announcement-bar-dismissed', '1');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartQuantity extends HTMLElement {
    connectedCallback() {
      this._key = this.dataset.key;
      this._qtyInput = this.querySelector('[data-qty-input]');
      this._qtyDecrease = this.querySelector('[data-qty-decrease]');
      this._qtyIncrease = this.querySelector('[data-qty-increase]');
      this._removeBtn = this.querySelector('[data-qty-remove]');

      // Determine inventory cap
      var invQty = parseInt(this.dataset.inventory, 10);
      var invPolicy = this.dataset.inventoryPolicy;
      this._maxQty = invPolicy !== 'continue' && !Number.isNaN(invQty) && invQty >= 0 ? invQty : null;
      if (this._qtyInput && this._maxQty !== null) {
        this._qtyInput.setAttribute('max', String(this._maxQty));
      }

      this._updateButtons();

      if (this._qtyDecrease) {
        this._qtyDecrease.addEventListener(
          'click',
          function () {
            this._change(-1);
          }.bind(this)
        );
      }
      if (this._qtyIncrease) {
        this._qtyIncrease.addEventListener(
          'click',
          function () {
            this._change(1);
          }.bind(this)
        );
      }
      if (this._removeBtn) {
        this._removeBtn.addEventListener(
          'click',
          function () {
            this._setQuantity(0);
          }.bind(this)
        );
      }
      if (this._qtyInput) {
        this._qtyInput.addEventListener(
          'change',
          function () {
            var val = parseInt(this._qtyInput.value, 10);
            if (Number.isNaN(val) || val < 1) val = 1;
            val = this._clamp(val);
            this._qtyInput.value = String(val);
            this._setQuantity(val);
          }.bind(this)
        );
      }
    }

    _updateButtons() {
      if (!this._qtyInput || !this._qtyDecrease) return;
      var qty = parseInt(this._qtyInput.value, 10);
      this._qtyDecrease.disabled = qty <= 1;
      if (this._qtyIncrease) {
        this._qtyIncrease.disabled = this._maxQty !== null && qty >= this._maxQty;
      }
    }

    _clamp(qty) {
      var n = Math.max(1, qty);
      if (this._maxQty !== null) n = Math.min(n, this._maxQty);
      return n;
    }

    _change(delta) {
      var current = parseInt(this._qtyInput.value, 10);
      if (Number.isNaN(current)) current = 1;
      var next = current + delta;
      if (next <= 0) {
        this._setQuantity(0);
        return;
      }
      this._setQuantity(this._clamp(next));
    }

    _setQuantity(qty) {
      this.classList.add('is-loading');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this._key, quantity: qty }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(
          function (cart) {
            if (qty <= 0) {
              this.remove();
            } else {
              this._qtyInput.value = String(qty);
              this._updateButtons();
              this.classList.remove('is-loading');

              // Update this item's line price
              var item = cart.items.find(
                function (i) {
                  return i.key === this._key;
                }.bind(this)
              );
              if (item) {
                var linePrice = this.querySelector('[data-item-line-price]');
                if (linePrice) linePrice.textContent = CartQuantity.formatMoney(item.line_price);
              }
            }

            this._updatePageTotals(cart);
          }.bind(this)
        )
        .catch(
          function () {
            this.classList.remove('is-loading');
          }.bind(this)
        );
    }

    _updatePageTotals(cart) {
      // Subtotal and total
      var formatted = CartQuantity.formatMoney(cart.total_price);
      var subtotalEl = document.querySelector('[data-cart-subtotal]');
      var totalEl = document.querySelector('[data-cart-total]');
      if (subtotalEl) subtotalEl.textContent = formatted;
      if (totalEl) totalEl.textContent = formatted;

      // Header cart count badge
      var badge = document.querySelector('[data-cart-count]');
      if (badge) {
        if (cart.item_count > 0) {
          badge.textContent = String(cart.item_count);
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }

      // Free shipping bar
      var bar = document.querySelector('[data-shipping-bar]');
      if (bar) {
        var threshold = parseInt(bar.dataset.threshold, 10);
        var pct = Math.min(100, (cart.total_price / threshold) * 100);
        var fill = bar.querySelector('[data-shipping-bar-fill]');
        var msg = bar.querySelector('[data-shipping-bar-message]');
        if (fill) fill.style.width = pct + '%';
        if (msg) {
          if (cart.total_price >= threshold) {
            msg.innerHTML = "You've unlocked free shipping!";
          } else {
            var remaining = threshold - cart.total_price;
            msg.innerHTML =
              "You're <strong>" + CartQuantity.formatMoney(remaining) + '</strong> away from free shipping';
          }
        }
      }

      // Disable checkout button when empty
      var checkoutBtn = document.querySelector('[data-checkout-button]');
      if (checkoutBtn) checkoutBtn.disabled = cart.item_count === 0;

      // Show empty state if all items removed
      if (cart.item_count === 0) {
        var itemsContainer = document.querySelector('[data-cart-items]');
        if (itemsContainer) {
          var empty = document.createElement('div');
          empty.className = 'py-16 flex flex-col items-start gap-5 text-center';
          empty.innerHTML =
            '<p class="font-medium text-gray-800">Your cart is empty.</p>' +
            '<a href="/" class="inline-flex items-center gap-1 rounded-full px-4 py-2 text-[0.8rem] no-underline transition-[opacity,filter] duration-100 hover:opacity-90 hover:brightness-95 text-(--color-secondary) bg-(--color-accent)">Continue Shopping<i class="ph ph-arrow-up-right text-sm"></i></a>';
          itemsContainer.replaceWith(empty);
        }
      }
    }
  }

  CartQuantity.formatMoney = function (cents) {
    var dollars = cents / 100;
    return '$' + dollars.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  if (!customElements.get('cart-quantity')) {
    customElements.define('cart-quantity', CartQuantity);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    // Filter panel — collapsible accordion on mobile, always open in the desktop sidebar
    var panel = document.getElementById('filter-panel');
    if (panel) {
      var rootStyles = getComputedStyle(document.documentElement);
      var mdBreakpoint = rootStyles.getPropertyValue('--breakpoint-md').trim() || '48rem';
      var mdMedia = window.matchMedia('(min-width: ' + mdBreakpoint + ')');
      var originalParent = panel.parentElement;
      var originalNextSibling = panel.nextElementSibling;

      function placePanelAfterToolbar() {
        var toolbar = document.querySelector('.filter-toolbar');
        if (toolbar && toolbar.nextElementSibling !== panel) {
          toolbar.insertAdjacentElement('afterend', panel);
        }
      }

      function placePanelInSidebar() {
        if (!originalParent) return;
        if (originalNextSibling && originalNextSibling.parentElement == originalParent) {
          originalParent.insertBefore(panel, originalNextSibling);
        } else {
          originalParent.appendChild(panel);
        }
      }

      function syncResponsiveFilterPanel() {
        if (mdMedia.matches) {
          placePanelInSidebar();
          panel.setAttribute('open', '');
        } else {
          placePanelAfterToolbar();
          panel.removeAttribute('open');
        }
        panel.classList.remove('hidden');
      }

      syncResponsiveFilterPanel();
      mdMedia.addEventListener('change', syncResponsiveFilterPanel);
    }

    // Apply button — disabled until a checkbox or price input changes
    var applyBtn = document.querySelector('#filter-form button[type="submit"]');
    if (applyBtn) {
      applyBtn.disabled = true;
      document.querySelectorAll('.filter-checkbox').forEach(function (cb) {
        cb.addEventListener('change', function () {
          applyBtn.disabled = false;
        });
      });
      document.querySelectorAll('.price-input').forEach(function (inp) {
        inp.addEventListener('input', function () {
          applyBtn.disabled = false;
        });
      });
    }

    // Sort select — update URL preserving other params
    var sortSelect = document.getElementById('sort-by');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-series"]) return;
  try {
    
  (function () {
    const link = document.querySelector('[data-event-back]');
    const label = link && link.querySelector('[data-event-back-label]');
    if (link && label && document.referrer) {
      try {
        const ref = new URL(document.referrer);
        if (ref.origin === window.location.origin && ref.pathname === '/pages/calendar') {
          link.href = '/pages/calendar';
          label.textContent = 'Calendar';
        }
      } catch (e) {}
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-page"] && !Shopify.designMode) return;
  try {
    
  class EventsLocationFilter extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-location-filter]'));
      this.active = new Set(this.buttons.map((b) => b.dataset.locationFilter));
      this.allCount = this.buttons.length;

      this.cards = Array.from(this.querySelectorAll('.events-page__track > [data-event-location]'));
      this.cells = Array.from(this.querySelectorAll('.events-page__cell'));
      this.moreWrap = this.querySelector('[data-events-more]');
      this.moreBtn = this.querySelector('[data-events-load-more]');
      this.upcomingEmpty = this.querySelector('[data-upcoming-empty]');
      this.pastEmpty = this.querySelector('[data-past-empty]');

      this.batch = parseInt(this.dataset.initialPast, 10) || 12;
      this.limit = this.batch;

      this.buttons.forEach((btn) => btn.addEventListener('click', () => this.toggle(btn)));
      if (this.moreBtn) {
        this.moreBtn.addEventListener('click', () => {
          this.limit += this.batch;
          this.apply();
        });
      }

      this.apply();
    }

    toggle(btn) {
      const key = btn.dataset.locationFilter;
      const on = !this.active.has(key);
      if (on) {
        this.active.add(key);
      } else {
        this.active.delete(key);
      }
      btn.setAttribute('aria-pressed', String(on));
      this.limit = this.batch; // paging restarts whenever the filter changes
      this.apply();
    }

    matches(card) {
      // Nothing narrowed — everything shows, including events whose
      // location name mentions none of the filters.
      if (this.active.size === this.allCount) return true;
      const loc = card.dataset.eventLocation || '';
      for (const key of this.active) {
        if (loc.indexOf(key) !== -1) return true;
      }
      return false;
    }

    apply() {
      let upcomingShown = 0;
      this.cards.forEach((card) => {
        const show = this.matches(card);
        card.hidden = !show;
        if (show) upcomingShown++;
      });
      if (this.upcomingEmpty) this.upcomingEmpty.hidden = upcomingShown > 0;

      let shown = 0;
      let matching = 0;
      this.cells.forEach((cell) => {
        const card = cell.querySelector('[data-event-location]');
        const ok = card ? this.matches(card) : false;
        if (ok) matching++;
        const show = ok && shown < this.limit;
        cell.hidden = !show;
        if (show) shown++;
      });
      if (this.pastEmpty) this.pastEmpty.hidden = matching > 0;
      if (this.moreWrap) this.moreWrap.hidden = matching <= this.limit;
    }
  }

  if (!customElements.get('events-location-filter')) {
    customElements.define('events-location-filter', EventsLocationFilter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var cols = document.querySelectorAll('.footer__col');
    var mq = window.matchMedia('(min-width: 768px)');

    function sync(isDesktop) {
      cols.forEach(function (el) {
        if (isDesktop) {
          el.setAttribute('open', '');
        } else {
          el.removeAttribute('open');
        }
      });
    }

    sync(mq.matches);
    mq.addEventListener('change', function (e) {
      sync(e.matches);
    });
  })();

  /* Currency selector: submit the localization form when the currency changes */
  (function () {
    var select = document.querySelector('[data-currency-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      this.form.submit();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var searchToggle = header.querySelector('[data-search-toggle]');
    var searchPanel = header.querySelector('[data-search-panel]');
    var searchInput = header.querySelector('[data-search-input]');
    var searchClose = header.querySelector('[data-search-close]');
    var searchResults = header.querySelector('[data-search-results]');
    var mobileMenu = header.querySelector('[data-mobile-menu]');
    var announcementBar = document.querySelector('[data-announcement-bar]');
    var searchUrl = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    var localeCode = header.dataset.locale || 'en-US';
    var currencyCode = header.dataset.currency || 'USD';
    var moneyFormatter = createMoneyFormatter();

    var debounceTimer = null;
    var abortController = null;

    function updateMobileNavOffset() {
      var announcementHeight = announcementBar && !announcementBar.hidden ? announcementBar.offsetHeight : 0;
      document.documentElement.style.setProperty('--mobile-nav-pb', announcementHeight + header.offsetHeight + 'px');
    }
    updateMobileNavOffset();
    window.addEventListener('resize', updateMobileNavOffset, { passive: true });

    // Desktop mega-menus are JS-driven. Hovering an item opens it; it closes when a
    // different item is hovered, or when the pointer leaves the nav list. Items are
    // flush edge-to-edge, so there is no dead space between them to fall through,
    // and the panel is a DOM descendant of its <li> — moving down into it never
    // counts as leaving the list, even though it renders below the header.
    var openNavItem = null;
    var navList = header.querySelector('[data-nav-desktop-list]');

    // The mega panel spans the full header width, but its content should start
    // where the first top-level link's text does — the logo's width isn't known
    // until it renders, so measure it rather than hard-coding an offset.
    function updateNavContentStart() {
      if (!navList) return;
      var firstLink = navList.querySelector('a');
      if (!firstLink) return;
      var linkRect = firstLink.getBoundingClientRect();
      if (!linkRect.width) return; // nav is hidden below lg — keep the last value
      var textInset = parseFloat(getComputedStyle(firstLink).paddingLeft) || 0;
      var offset = linkRect.left - header.getBoundingClientRect().left + textInset;
      document.documentElement.style.setProperty('--nav-content-start', offset + 'px');
    }
    updateNavContentStart();
    window.addEventListener('resize', updateNavContentStart, { passive: true });
    window.addEventListener('load', updateNavContentStart);
    if (typeof ResizeObserver === 'function' && navList) {
      new ResizeObserver(updateNavContentStart).observe(navList);
    }

    // Calls done once el's fade-out animation finishes, or straight away when no
    // animation is running (e.g. the browser still has stale CSS) so a close can
    // never get stuck. A fade cancelled by reopening never calls done.
    function afterFadeOut(el, done) {
      var animations = typeof el.getAnimations === 'function' ? el.getAnimations() : [];
      if (!animations.length) {
        done();
        return;
      }
      Promise.all(
        animations.map(function (a) {
          return a.finished;
        })
      ).then(done, function () {});
    }

    // A panel fading out after the pointer leaves the nav. Kept rendered via
    // data-nav-closing until its fade-out animation ends.
    var closingNavItem = null;

    function finishClosingNavItem() {
      if (!closingNavItem) return;
      closingNavItem.removeAttribute('data-nav-closing');
      closingNavItem = null;
    }

    function closeNavItem(fade) {
      if (!openNavItem) return;
      finishClosingNavItem();
      var item = openNavItem;
      item.removeAttribute('data-nav-open');
      openNavItem = null;
      if (!fade) return;
      item.setAttribute('data-nav-closing', '');
      closingNavItem = item;
      afterFadeOut(item.querySelector('.nav-desktop__mega'), function () {
        if (closingNavItem === item) finishClosingNavItem();
      });
    }

    function activateNavItem(item) {
      if (openNavItem === item) return;
      // Coming back while a panel is still fading out counts as switching, so the
      // new panel appears instantly instead of overlapping a fade-out with a fade-in.
      // Moving onto a link with no dropdown is a close, not a switch — fade it out.
      if (!item.hasAttribute('data-nav-mega-trigger')) {
        closeNavItem(true);
        return;
      }
      var switching = !!openNavItem || !!closingNavItem;
      finishClosingNavItem();
      closeNavItem();
      item.toggleAttribute('data-nav-instant', switching);
      // Close and reset search when a mega-menu opens, so the two overlays never
      // stack on top of each other.
      if (!searchPanel.hidden) closeSearch();
      item.setAttribute('data-nav-open', '');
      openNavItem = item;
    }

    // The items fill the header's height so an open menu survives the pointer
    // drifting up or down, but opening one from nothing requires the pointer to be
    // over the link itself (text + its vertical padding) — brushing the header's
    // top or bottom edge shouldn't pop a menu. Once one is open, switching is
    // full-height.
    function isInHitZone(item, e) {
      var hit = item.querySelector('[data-nav-hit]');
      if (!hit) return true;
      var rect = hit.getBoundingClientRect();
      return e.clientY >= rect.top && e.clientY <= rect.bottom;
    }

    header.querySelectorAll('[data-nav-desktop-item]').forEach(function (item) {
      function onItemPointer(e) {
        if (openNavItem === item) return;
        if (!openNavItem && !isInHitZone(item, e)) return;
        // Clicking a top-level link leaves it focused, and :focus-within would keep
        // its panel open alongside the newly hovered one. Drop that focus first.
        var active = document.activeElement;
        if (active && typeof active.closest === 'function') {
          var activeItem = active.closest('[data-nav-desktop-item]');
          if (activeItem && activeItem !== item) active.blur();
        }
        activateNavItem(item);
      }
      item.addEventListener('mouseenter', onItemPointer);
      item.addEventListener('mousemove', onItemPointer);
    });

    if (navList) {
      navList.addEventListener('mouseleave', function () {
        closeNavItem(true);
      });
    }

    function createMoneyFormatter() {
      try {
        return new Intl.NumberFormat(localeCode || 'en-US', {
          style: 'currency',
          currency: currencyCode || 'USD',
        });
      } catch (err) {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        });
      }
    }

    function parseDecimal(value) {
      var numeric = typeof value === 'number' ? value : parseFloat(value);
      return Number.isFinite(numeric) ? numeric : null;
    }

    function formatMoney(value) {
      if (value === null) return '';
      return moneyFormatter.format(value);
    }

    function buildProductPriceRow(product) {
      var row = document.createElement('span');
      row.className = 'header__search-result-price-row';

      if (product.available === false) {
        var soldOut = document.createElement('span');
        soldOut.className = 'header__search-result-sold-out';
        soldOut.textContent = 'Sold Out';
        row.appendChild(soldOut);
        return row;
      }

      var price = parseDecimal(product.price);
      var priceMin = parseDecimal(product.price_min);
      var priceMax = parseDecimal(product.price_max);
      var compareAtMax = parseDecimal(product.compare_at_price_max);

      var hasRange = priceMin !== null && priceMax !== null && priceMin !== priceMax;
      var saleCompareBase = hasRange ? priceMin : price;
      if (saleCompareBase === null) saleCompareBase = priceMin;
      if (saleCompareBase === null) saleCompareBase = priceMax;
      if (saleCompareBase === null) return null;

      var currentPrice = document.createElement('span');
      currentPrice.className = 'header__search-result-price';

      if (hasRange) {
        currentPrice.textContent = formatMoney(priceMin) + ' - ' + formatMoney(priceMax);
      } else {
        currentPrice.textContent = formatMoney(saleCompareBase);
      }

      var isOnSale = compareAtMax !== null && compareAtMax > saleCompareBase;
      if (isOnSale) {
        currentPrice.classList.add('header__search-result-price--sale');
      }
      row.appendChild(currentPrice);

      if (isOnSale) {
        var compareAt = document.createElement('span');
        compareAt.className = 'header__search-result-compare-at';
        compareAt.textContent = formatMoney(compareAtMax);
        row.appendChild(compareAt);
      }

      return row;
    }

    function openSearch() {
      if (mobileMenu && mobileMenu.open) mobileMenu.open = false;
      searchPanel.removeAttribute('data-search-closing');
      searchPanel.hidden = false;
      searchToggle.setAttribute('aria-expanded', 'true');
      searchInput.focus();
    }

    // fade: play the fade-out first and finish closing once it ends. Closes
    // triggered by another overlay opening stay instant so the two never overlap.
    function closeSearch(fade) {
      if (fade === true && !searchPanel.hidden) {
        searchPanel.setAttribute('data-search-closing', '');
        searchToggle.setAttribute('aria-expanded', 'false');
        afterFadeOut(searchPanel, function () {
          if (searchPanel.hasAttribute('data-search-closing')) closeSearch();
        });
        return;
      }
      searchPanel.removeAttribute('data-search-closing');
      searchPanel.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
      searchInput.value = '';
      searchResults.textContent = '';
      if (abortController) abortController.abort();
      clearTimeout(debounceTimer);
    }

    searchToggle.addEventListener('click', function () {
      searchPanel.hidden || searchPanel.hasAttribute('data-search-closing') ? openSearch() : closeSearch(true);
    });

    searchClose.addEventListener('click', function () {
      closeSearch(true);
    });

    // Hover-opening dismisses search in activateNavItem; keyboard focus opens the
    // panel via :focus-within, so dismiss search here too.
    header.querySelectorAll('[data-nav-mega-trigger]').forEach(function (item) {
      item.addEventListener('focusin', function () {
        if (!searchPanel.hidden) closeSearch();
      });
    });

    if (mobileMenu) {
      mobileMenu.addEventListener('toggle', function () {
        if (mobileMenu.open && !searchPanel.hidden) closeSearch();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !searchPanel.hidden) closeSearch(true);
    });

    document.addEventListener('click', function (e) {
      if (header.contains(e.target)) return;
      if (!searchPanel.hidden) closeSearch(true);
      // Touch/pen taps fire a synthetic mouseenter but never a mouseleave, so an
      // open panel needs an explicit dismissal path.
      closeNavItem(true);
    });

    var lgBreakpoint = window.matchMedia('(min-width: 64rem)');
    lgBreakpoint.addEventListener('change', function (e) {
      if (e.matches && mobileMenu && mobileMenu.open) {
        mobileMenu.open = false;
      }
    });

    // <details> closes instantly, so intercept the hamburger tap on an open mobile
    // menu, fade the panel out, then close it once the fade ends.
    if (mobileMenu) {
      var mobileSummary = mobileMenu.querySelector(':scope > summary');
      var mobilePanel = mobileMenu.querySelector(':scope > .header__mobile-panel');

      mobileSummary.addEventListener('click', function (e) {
        if (!mobileMenu.open) return;
        e.preventDefault();
        if (mobileMenu.hasAttribute('data-nav-closing')) return;
        mobileMenu.setAttribute('data-nav-closing', '');
        afterFadeOut(mobilePanel, function () {
          if (!mobileMenu.hasAttribute('data-nav-closing')) return;
          mobileMenu.removeAttribute('data-nav-closing');
          mobileMenu.open = false;
        });
      });

      // A programmatic close (search opening, breakpoint change) mid-fade cancels
      // the fade, so it never finishes — clear the flag here instead.
      mobileMenu.addEventListener('toggle', function () {
        if (!mobileMenu.open) mobileMenu.removeAttribute('data-nav-closing');
      });
    }

    if (mobileMenu) {
      mobileMenu.addEventListener('toggle', function () {
        if (mobileMenu.open) updateMobileNavOffset();
      });
    }

    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      if (abortController) abortController.abort();

      var query = searchInput.value.trim();
      if (!query) {
        searchResults.textContent = '';
        return;
      }

      debounceTimer = setTimeout(function () {
        fetchResults(query);
      }, 0);
    });

    function fetchResults(query) {
      abortController = new AbortController();
      var signal = abortController.signal;
      var url =
        searchUrl +
        '.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product,article,page,collection' +
        '&resources[limit]=6' +
        '&resources[limit_scope]=each' +
        '&resources[unavailable_products]=last';

      // Routes and events are metaobjects, so Shopify's predictive search index
      // never returns them. sections/predictive-search.liquid matches them in
      // Liquid and comes back as ready-made dropdown groups.
      var metaobjectUrl = searchUrl + '?q=' + encodeURIComponent(query) + '&section_id=predictive-search';

      Promise.all([
        fetch(url, { signal: signal }).then(function (res) {
          return res.json();
        }),
        fetch(metaobjectUrl, { signal: signal })
          .then(function (res) {
            return res.ok ? res.text() : '';
          })
          .catch(function (err) {
            // A failed metaobject lookup shouldn't blank out the whole dropdown
            if (err.name === 'AbortError') throw err;
            return '';
          }),
      ])
        .then(function (responses) {
          renderResults(responses[0], responses[1], query);
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') console.error(err);
        });
    }

    function parseMetaobjectGroups(html) {
      if (!html) return [];
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return Array.prototype.slice.call(doc.querySelectorAll('.shopify-section > section'));
    }

    function createResultLink(href) {
      var a = document.createElement('a');
      a.href = href;
      a.className = 'header__search-result';
      return a;
    }

    function appendImage(parent, src, alt) {
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = alt || '';
        img.className = 'header__search-result-img';
        img.style.objectFit = 'contain';
        img.loading = 'lazy';
        parent.appendChild(img);
      } else {
        var placeholder = document.createElement('span');
        placeholder.className = 'header__search-result-img header__search-result-img--placeholder';
        parent.appendChild(placeholder);
      }
    }

    function appendInfo(parent, title, secondary) {
      var info = document.createElement('div');
      info.className = 'header__search-result-info';

      var titleEl = document.createElement('span');
      titleEl.className = 'header__search-result-title';
      titleEl.textContent = title;
      info.appendChild(titleEl);

      if (secondary) {
        var sec = document.createElement('span');
        sec.className = 'header__search-result-price';
        sec.textContent = secondary;
        info.appendChild(sec);
      }

      parent.appendChild(info);
      return info;
    }

    function buildProductRow(product) {
      var a = createResultLink(product.url);
      appendImage(a, product.image ? product.image + '&width=100' : null, product.title);
      var info = document.createElement('div');
      info.className = 'header__search-result-info';
      var title = document.createElement('span');
      title.className = 'header__search-result-title';
      title.textContent = product.title;
      info.appendChild(title);
      var priceRow = buildProductPriceRow(product);
      if (priceRow) info.appendChild(priceRow);
      a.appendChild(info);
      return a;
    }

    function truncate(text, max) {
      if (!text || text.length <= max) return text;
      var cut = text.slice(0, max);
      var lastSpace = cut.lastIndexOf(' ');
      if (lastSpace > 0) cut = cut.slice(0, lastSpace);
      return cut + '…';
    }

    function buildArticleRow(article) {
      var a = createResultLink(article.url);
      var secondary = '';
      if (article.summary_html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = article.summary_html;
        secondary = (tmp.textContent || '').trim();
      } else if (article.excerpt) {
        secondary = article.excerpt;
      } else if (article.author) {
        secondary = article.author;
      }
      appendInfo(a, article.title, truncate(secondary, 100));
      return a;
    }

    function buildPageRow(page) {
      var a = createResultLink(page.url);
      appendInfo(a, page.title, '');
      return a;
    }

    function buildCollectionRow(collection) {
      var a = createResultLink(collection.url);
      appendInfo(a, collection.title, '');
      return a;
    }

    function buildGroup(label, items, builder) {
      if (!items || !items.length) return null;
      var section = document.createElement('section');
      var heading = document.createElement('h4');
      heading.className = 'header__search-group-heading text-sm font-base';
      heading.textContent = label;
      section.appendChild(heading);
      items.forEach(function (item) {
        section.appendChild(builder(item));
      });
      return section;
    }

    function renderResults(data, metaobjectHtml, query) {
      searchResults.textContent = '';

      var results = (data.resources && data.resources.results) || {};
      var products = (results.products || []).slice(0, 6);
      var articles = (results.articles || []).slice(0, 2);
      var pages = (results.pages || []).slice(0, 2);
      var collections = (results.collections || []).slice(0, 2);
      var metaobjectGroups = parseMetaobjectGroups(metaobjectHtml);

      var grid = document.createElement('div');
      grid.className = 'header__search-grid';

      var metaobjectCount = metaobjectGroups.reduce(function (sum, group) {
        return sum + group.querySelectorAll('[data-metaobject-result]').length;
      }, 0);
      var totalCount = products.length + articles.length + pages.length + collections.length + metaobjectCount;

      if (totalCount === 0) {
        var empty = document.createElement('p');
        empty.className = 'text-sm opacity-60 py-2 header__search-span-all';
        empty.textContent = 'No results found for \u201c' + query + '\u201d';
        grid.appendChild(empty);
        searchResults.appendChild(grid);
        return;
      }

      var groups = [
        buildGroup('Products', products, buildProductRow),
        buildGroup('Collections', collections, buildCollectionRow),
      ];

      // Routes/Events arrive pre-rendered from Liquid, so they're adopted as-is
      metaobjectGroups.forEach(function (group) {
        groups.push(document.adoptNode(group));
      });

      groups.push(buildGroup('Articles', articles, buildArticleRow));
      groups.push(buildGroup('Pages', pages, buildPageRow));

      groups.forEach(function (group) {
        if (group) grid.appendChild(group);
      });

      var viewAllTemplate = header.querySelector('[data-view-all-template]');
      if (viewAllTemplate) {
        var viewAllWrap = document.createElement('div');
        viewAllWrap.className = 'header__search-span-all mb-2';
        var viewAll = viewAllTemplate.content.firstElementChild.cloneNode(true);
        // Routes, events, articles and pages all live under the Articles tab —
        // land there when the query didn't turn up any products
        var viewAllType = products.length ? 'product' : 'article,page';
        viewAll.href = '/search?q=' + encodeURIComponent(query) + '&type=' + encodeURIComponent(viewAllType);
        viewAllWrap.appendChild(viewAll);
        grid.appendChild(viewAllWrap);
      }

      searchResults.appendChild(grid);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var carousels = document.querySelectorAll('[data-hero-carousel]');
    if (carousels.length === 0) return;

    carousels.forEach(function (carousel) {
      var slideElements = carousel.querySelectorAll('[data-slide-index]');
      var indicators = carousel.querySelectorAll('[data-hero-indicator]');
      var totalSlides = slideElements.length;

      if (totalSlides === 0) return;

      var currentSlide = 0;
      slideElements.forEach(function (slide, index) {
        if (slide.dataset.active === 'true') currentSlide = index;
      });

      if (totalSlides <= 1) return;

      var intervalSeconds = parseInt(carousel.dataset.interval, 10) || 5;
      var intervalMs = intervalSeconds * 1000;

      var autoAdvanceInterval = setInterval(function () {
        goToSlide(currentSlide + 1, false);
      }, intervalMs);

      function goToSlide(index, stop) {
        if (stop) {
          clearInterval(autoAdvanceInterval);
        }

        currentSlide = (index + totalSlides) % totalSlides;

        slideElements.forEach(function (slide, slideIndex) {
          slide.dataset.active = slideIndex === currentSlide ? 'true' : 'false';

          var videos = slide.querySelectorAll('[data-hero-video]');
          videos.forEach(function (video) {
            if (slideIndex === currentSlide) {
              video.play();
            } else {
              video.pause();
            }
          });
        });

        indicators.forEach(function (indicator, indicatorIndex) {
          indicator.setAttribute('aria-current', indicatorIndex === currentSlide ? 'true' : 'false');
        });
      }

      // Touch swipe: left = next, right = previous
      var touchStartX = 0;
      var touchStartY = 0;
      var tracking = false;
      var swiped = false;

      carousel.addEventListener(
        'touchstart',
        function (e) {
          swiped = false;
          tracking = e.touches.length === 1;
          if (!tracking) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        },
        { passive: true }
      );

      carousel.addEventListener(
        'touchend',
        function (e) {
          if (!tracking) return;
          tracking = false;
          var dx = e.changedTouches[0].clientX - touchStartX;
          var dy = e.changedTouches[0].clientY - touchStartY;
          if (Math.abs(dx) < 50 || Math.abs(dx) <= Math.abs(dy)) return;
          swiped = true;
          goToSlide(currentSlide + (dx < 0 ? 1 : -1), true);
        },
        { passive: true }
      );

      // Trackpad two-finger swipe. Inertia keeps firing wheel events for a second
      // or more after the fingers lift, so lock after one slide change. Inertia
      // only ever decays, so the lock lifts when the events go quiet, flip
      // direction, or speed back up (a new swipe started mid-inertia).
      var wheelDelta = 0;
      var wheelLocked = false;
      var wheelLockedAt = 0;
      var wheelLastAbs = 0;
      var wheelTimer = null;

      function resetWheel() {
        wheelDelta = 0;
        wheelLocked = false;
      }

      carousel.addEventListener(
        'wheel',
        function (e) {
          if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
          e.preventDefault();

          var abs = Math.abs(e.deltaX);
          var now = Date.now();

          clearTimeout(wheelTimer);
          wheelTimer = setTimeout(resetWheel, 200);

          if (wheelLocked) {
            // The triggering swipe is still accelerating for a few hundred ms
            // after it fires, so only treat a rise as a new swipe after that.
            var settled = now - wheelLockedAt > 350;
            var reversed = e.deltaX > 0 !== wheelDelta > 0;
            var rising = abs > wheelLastAbs * 1.5 && abs > 6;
            wheelLastAbs = abs;
            if (!settled || (!reversed && !rising)) return;
            resetWheel();
          }

          wheelLastAbs = abs;
          wheelDelta += e.deltaX;
          if (Math.abs(wheelDelta) < 30) return;
          wheelLocked = true;
          wheelLockedAt = now;
          goToSlide(currentSlide + (wheelDelta > 0 ? 1 : -1), true);
        },
        { passive: false }
      );

      // Left/right tap zones
      carousel.addEventListener('click', function (e) {
        if (swiped) {
          swiped = false;
          return;
        }
        if (e.target.closest('a, button')) return;

        var rect = carousel.getBoundingClientRect();
        var midX = rect.left + rect.width / 2;

        if (e.clientX >= midX) {
          goToSlide(currentSlide + 1, true);
        } else {
          goToSlide(currentSlide - 1, true);
        }
      });

      indicators.forEach(function (indicator, index) {
        indicator.addEventListener('click', function () {
          goToSlide(index, true);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var carousels = document.querySelectorAll('[data-product-carousel]');
    if (!carousels.length) return;

    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-product-carousel-track]');
      var prev = carousel.querySelector('[data-product-carousel-prev]');
      var next = carousel.querySelector('[data-product-carousel-next]');
      if (!track || !prev || !next) return;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function initProductPage(productRoot) {
      if (!productRoot) return;

      var productSection = productRoot.closest('.shopify-section');
      if (!productSection) return;

      var jsonNode = productSection.querySelector('[data-product-variants-json]');
      var variants = [];
      try {
        variants = jsonNode ? JSON.parse(jsonNode.textContent) : [];
      } catch (error) {
        variants = [];
      }

      var optionGroups = Array.prototype.slice.call(productRoot.querySelectorAll('[data-option-group]'));
      var optionInputs = Array.prototype.slice.call(productRoot.querySelectorAll('[data-option-input]'));
      var colorwaySwatches = Array.prototype.slice.call(productRoot.querySelectorAll('[data-colorway-swatch]'));
      var variantIdInput = productRoot.querySelector('[data-variant-id-input]');
      var addButton = productRoot.querySelector('[data-add-to-cart-button]');
      var priceBlocks = Array.prototype.slice.call(productRoot.querySelectorAll('[data-price-variant]'));
      var variantTitleBlocks = Array.prototype.slice.call(productRoot.querySelectorAll('[data-variant-title]'));
      var pickupContainer = productRoot.querySelector('[data-pickup-container]');
      var pickupGroup = productRoot.querySelector('[data-pickup-group]');
      var preorderNote = productRoot.querySelector('[data-preorder-note]');
      var productFormEl = productRoot.querySelector('[data-product-form]');
      var productHandle = productFormEl ? productFormEl.getAttribute('data-product-handle') : null;
      var gallerySlides = Array.prototype.slice.call(productRoot.querySelectorAll('[data-gallery-slide]'));
      var galleryThumbs = Array.prototype.slice.call(productRoot.querySelectorAll('[data-gallery-thumb]'));
      var gallerySlidesEl = productRoot.querySelector('[data-gallery-slides]');
      var galleryFadeEl = productRoot.querySelector('[data-gallery-fade]');
      var galleryFade = null;
      var qtyInput = productRoot.querySelector('[data-qty-input]');
      var qtyDecrease = productRoot.querySelector('[data-qty-decrease]');
      var qtyIncrease = productRoot.querySelector('[data-qty-increase]');
      var cartQuantities = {};
      var activeMediaId = null;
      // The stage is a carousel at every breakpoint, so its scroll position is
      // the displayed image. This tracks a scroll we caused ourselves, which
      // must never be mistaken for the shopper choosing an image.
      var pendingScrollId = null; // target of an in-flight programmatic scroll

      function toggleVariantBlock(blocks, variantId) {
        blocks.forEach(function (block) {
          var isMatch = block.getAttribute('data-variant-id') === String(variantId);
          block.classList.toggle('hidden', !isMatch);
        });
      }

      function updatePickupAvailability(variantId) {
        if (!pickupContainer || !productHandle) return;
        fetch('/products/' + productHandle + '?variant=' + variantId + '&sections=pickup-availability')
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            var html = data['pickup-availability'];
            if (html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var sectionEl = doc.querySelector('.shopify-section') || doc.body;
              pickupContainer.innerHTML = sectionEl.innerHTML;
            }
          })
          .catch(function () {});
      }

      function updateQtyButtons() {
        if (!qtyInput || !qtyDecrease || !qtyIncrease) return;
        var current = parseInt(qtyInput.value, 10);
        var min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
        var max = parseInt(qtyInput.getAttribute('max'), 10);
        qtyDecrease.disabled = current <= min;
        qtyIncrease.disabled = !Number.isNaN(max) && current >= max;
      }

      function updateQtyMax(variant) {
        if (!qtyInput || !variant) return;
        if (variant.inventory_policy === 'continue') {
          qtyInput.removeAttribute('max');
          updateQtyButtons();
          return;
        }
        var inCart = cartQuantities[variant.id] || 0;
        var available = Math.max(0, variant.inventory_quantity - inCart);
        qtyInput.setAttribute('max', String(available || 1));
        var current = parseInt(qtyInput.value, 10);
        if (!Number.isNaN(current) && current > available) {
          qtyInput.value = String(Math.max(1, available));
        }
        updateQtyButtons();
      }

      // Update only the thumbnail active state (used by swipe, where the
      // carousel scroll position already reflects the visible slide).
      function updateActiveThumb(mediaId) {
        if (!mediaId) return;
        activeMediaId = String(mediaId);

        galleryThumbs.forEach(function (thumb) {
          var isMatch = thumb.getAttribute('data-target-media-id') === activeMediaId;
          thumb.classList.toggle('is-active', isMatch);
          thumb.setAttribute('aria-current', isMatch ? 'true' : 'false');
        });
      }

      // Scroll the carousel to the slide for a given media id.
      function scrollToMedia(mediaId, smooth) {
        if (!gallerySlidesEl) return;
        var slide = null;
        gallerySlides.forEach(function (s) {
          if (s.getAttribute('data-media-id') === String(mediaId)) slide = s;
        });
        if (!slide) return;
        pendingScrollId = String(mediaId);
        gallerySlidesEl.scrollTo({
          left: slide.offsetLeft,
          behavior: smooth ? 'smooth' : 'auto',
        });
      }

      function setActiveMedia(mediaId) {
        if (!mediaId) return;
        updateActiveThumb(mediaId);
        scrollToMedia(mediaId, true);
      }

      // Built on first use: section scripts run before the deferred
      // assets/image-crossfade.js in theme.liquid has defined ImageCrossfade.
      function getGalleryFade() {
        if (!galleryFade && galleryFadeEl && window.ImageCrossfade) {
          galleryFade = new window.ImageCrossfade(galleryFadeEl);
        }
        return galleryFade;
      }

      // Hover preview: crossfade a copy of the slide over the stage, leaving
      // the carousel where it is. Previewing the active image fades back to the
      // stage itself.
      function previewMedia(mediaId) {
        var fade = getGalleryFade();
        if (!fade) return;
        if (mediaId === activeMediaId) {
          fade.clear();
          return;
        }
        var slide = null;
        gallerySlides.forEach(function (s) {
          if (s.getAttribute('data-media-id') === String(mediaId)) slide = s;
        });
        if (!slide || !slide.firstElementChild) return;

        // The copy keeps srcset/sizes, so an image the stage already loaded is
        // a cache hit; a lazy slide never scrolled into view is fetched now.
        var copy = slide.firstElementChild.cloneNode(true);
        var copyImg = copy.querySelector('img');
        if (copyImg) {
          copyImg.setAttribute('loading', 'eager');
          copyImg.removeAttribute('fetchpriority');
        }
        var layer = document.createElement('div');
        layer.className = 'absolute inset-0 bg-[#eff1f2]';
        layer.appendChild(copy);
        fade.show(layer);
      }

      function getSelectedOptions() {
        return optionGroups.map(function (group) {
          var checkedInput = group.querySelector('[data-option-input]:checked');
          return checkedInput ? checkedInput.value : '';
        });
      }

      function findVariantFromSelections() {
        if (!optionGroups.length) {
          return variants[0] || null;
        }

        var selectedValues = getSelectedOptions();
        for (var i = 0; i < variants.length; i += 1) {
          var variant = variants[i];
          if (!variant || !variant.options || variant.options.length !== selectedValues.length) {
            continue;
          }
          var isMatch = variant.options.every(function (value, index) {
            return value === selectedValues[index];
          });
          if (isMatch) return variant;
        }
        return null;
      }

      function getVariantState(variant) {
        if (!variant) return 'unavailable';
        if (!variant.available) return 'sold_out';
        // continue = oversell allowed, so "all in cart" can never apply
        if (variant.inventory_policy !== 'continue') {
          var inCart = cartQuantities[variant.id] || 0;
          if (variant.inventory_quantity - inCart <= 0) return 'all_in_cart';
        }
        return 'available';
      }

      function setAddButtonState(state) {
        if (!addButton) return;
        var labels = {
          // "Pre-order" on pre-order products, set by Liquid on the button
          available: addButton.getAttribute('data-available-label') || 'Add to cart',
          sold_out: 'Sold out',
          all_in_cart: 'All Stock in Cart',
          unavailable: 'Unavailable',
        };
        addButton.disabled = state !== 'available';
        addButton.textContent = labels[state] || labels.unavailable;
        var paymentButtons = productRoot.querySelector('[data-payment-buttons]');
        if (paymentButtons) paymentButtons.classList.toggle('payment-buttons--sold-out', state !== 'available');
      }

      function updateOptionAvailability() {
        var selectedValues = getSelectedOptions();

        optionGroups.forEach(function (group, groupIndex) {
          var labels = group.querySelectorAll('label[data-option-value]');
          labels.forEach(function (label) {
            var value = label.getAttribute('data-option-value');

            var isAvailable = variants.some(function (variant) {
              if (!variant.available) return false;
              if (variant.options[groupIndex] !== value) return false;
              return selectedValues.every(function (selectedVal, idx) {
                if (idx === groupIndex) return true;
                if (!selectedVal) return true;
                return variant.options[idx] === selectedVal;
              });
            });

            label.setAttribute('data-sold-out', isAvailable ? 'false' : 'true');
          });
        });

        updateColorwayAvailability();
      }

      // The size options currently chosen, keyed by option name. Colour is
      // excluded: a colourway sibling carries its own single colour, so
      // matching on it would never find anything.
      function getSelectedSizeOptions() {
        var selected = {};
        optionGroups.forEach(function (group) {
          if (group.getAttribute('data-is-color') === 'true') return;
          var name = group.getAttribute('data-option-name');
          var checkedInput = group.querySelector('[data-option-input]:checked');
          if (name && checkedInput) selected[name] = checkedInput.value;
        });
        return selected;
      }

      function parseSwatchJSON(swatch, attribute) {
        try {
          return JSON.parse(swatch.getAttribute(attribute) || 'null');
        } catch (error) {
          return null;
        }
      }

      // Colourways are separate products, so they can't be a variant option and
      // don't get the cross-option availability above for free. This is the
      // equivalent pass over them: mark a colourway sold out when it has no
      // available variant in the selected size, and carry that size across the
      // jump so the sibling opens on it rather than on its own first available.
      function updateColorwayAvailability() {
        if (!colorwaySwatches.length) return;

        var selected = getSelectedSizeOptions();

        colorwaySwatches.forEach(function (swatch) {
          var names = parseSwatchJSON(swatch, 'data-option-names');
          var rows = parseSwatchJSON(swatch, 'data-variants');

          // No usable data — leave the server-rendered product-level state be
          // rather than overwriting it with a guess.
          if (!Array.isArray(names) || !Array.isArray(rows) || !names.length || !rows.length) return;

          // Constrain only on options this sibling actually has. A colourway
          // whose size option is named differently is not evidence that the
          // selected size is gone.
          var keys = names.filter(function (name) {
            return Object.prototype.hasOwnProperty.call(selected, name);
          });

          var match = null;
          var hasAvailable = false;

          rows.forEach(function (row) {
            var isMatch = keys.every(function (name) {
              return row[names.indexOf(name) + 2] === selected[name];
            });
            if (!isMatch) return;
            // Prefer an in-stock row for the link; fall back to a sold-out one
            // so the sibling still lands on the size the shopper asked for.
            if (!match || (row[1] === 1 && match[1] !== 1)) match = row;
            if (row[1] === 1) hasAvailable = true;
          });

          swatch.setAttribute('data-sold-out', hasAvailable ? 'false' : 'true');

          if (swatch.getAttribute('aria-current') !== 'page') {
            var baseUrl = swatch.getAttribute('data-base-url') || swatch.getAttribute('href');
            var separator = baseUrl.indexOf('?') === -1 ? '?' : '&';
            swatch.setAttribute('href', match ? baseUrl + separator + 'variant=' + match[0] : baseUrl);
          }

          var status = swatch.querySelector('[data-colorway-status]');
          if (status) {
            var name = swatch.getAttribute('data-colorway-name') || '';
            status.textContent = hasAvailable ? name : name + ' — sold out';
          }
        });
      }

      function syncVariantUI(variant) {
        if (!variant) {
          if (variantIdInput) variantIdInput.value = '';
          priceBlocks.concat(variantTitleBlocks).forEach(function (block) {
            block.classList.add('hidden');
          });
          if (pickupContainer)
            pickupContainer.innerHTML =
              '<p class="text-sm text-gray-500">Pickup is not available for this variant.</p>';
          setAddButtonState('unavailable');
          if (preorderNote) preorderNote.classList.add('hidden');
          return;
        }

        if (variantIdInput) {
          variantIdInput.value = variant.id;
        }

        toggleVariantBlock(priceBlocks, variant.id);
        toggleVariantBlock(variantTitleBlocks, variant.id);
        // Pre-order products aren't offered for pickup, so pickup is hidden.
        var showPickup = variant.requires_shipping && !variant.preorder;
        if (pickupGroup) {
          pickupGroup.classList.toggle('hidden', !showPickup);
        }
        if (showPickup) {
          updatePickupAvailability(variant.id);
        }
        updateQtyMax(variant);
        setAddButtonState(getVariantState(variant));
        if (preorderNote) preorderNote.classList.toggle('hidden', !variant.preorder);

        if (variant.featured_image_id) {
          setActiveMedia(variant.featured_image_id);
        }
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          syncVariantUI(findVariantFromSelections());
          updateOptionAvailability();
        });
      });

      galleryThumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var mediaId = thumb.getAttribute('data-target-media-id');
          updateActiveThumb(mediaId);
          // Under a hover preview the scroll is hidden, so jump: the stage then
          // already matches when the preview fades away.
          scrollToMedia(mediaId, !(galleryFade && galleryFade.active));
        });

        // Hover previews an image without committing it, crossfading like the
        // product card hover.
        //
        // Mouse only: a tap on iOS synthesises an enter but no matching leave,
        // which would leave the preview stuck over the stage.
        thumb.addEventListener('pointerenter', function (event) {
          if (event.pointerType !== 'mouse') return;
          previewMedia(thumb.getAttribute('data-target-media-id'));
        });

        thumb.addEventListener('pointerleave', function (event) {
          if (event.pointerType !== 'mouse') return;
          // Moving straight onto another thumb: its enter takes over. Clearing
          // here would start fading back to the stage for a frame first.
          var next = event.relatedTarget;
          if (next && next.nodeType === 1 && next.closest('[data-gallery-thumb]')) return;
          if (galleryFade) galleryFade.clear();
        });
      });

      // Swipe (touch or trackpad) → sync the active thumbnail to the centered
      // slide. Our own scrolls are excluded: a smooth scroll passes over slides
      // on its way to the target.
      if (gallerySlidesEl) {
        var scrollRaf = null;
        gallerySlidesEl.addEventListener(
          'scroll',
          function () {
            if (scrollRaf) window.cancelAnimationFrame(scrollRaf);
            scrollRaf = window.requestAnimationFrame(function () {
              var center = gallerySlidesEl.scrollLeft + gallerySlidesEl.clientWidth / 2;
              var closest = null;
              var closestDist = Infinity;
              gallerySlides.forEach(function (slide) {
                var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
                var dist = Math.abs(slideCenter - center);
                if (dist < closestDist) {
                  closestDist = dist;
                  closest = slide;
                }
              });
              if (!closest) return;
              var mediaId = closest.getAttribute('data-media-id');
              if (pendingScrollId) {
                if (mediaId === pendingScrollId) pendingScrollId = null;
                return;
              }
              if (mediaId !== activeMediaId) updateActiveThumb(mediaId);
            });
          },
          { passive: true }
        );

        // A real gesture takes over from any programmatic scroll, so one that is
        // interrupted (or never moves) can't leave the sync suppressed. The
        // gesture is on the stage, so no thumbnail can be under the pointer —
        // any lingering hover preview is stale and is cleared with it.
        ['wheel', 'touchstart', 'pointerdown'].forEach(function (evt) {
          gallerySlidesEl.addEventListener(
            evt,
            function () {
              pendingScrollId = null;
              if (galleryFade) galleryFade.clear();
            },
            { passive: true }
          );
        });

        // Start the carousel on the initially-active image (may not be the first).
        var initialMediaId = gallerySlidesEl.getAttribute('data-initial-media-id');
        if (initialMediaId) {
          activeMediaId = initialMediaId;
          scrollToMedia(activeMediaId, false);
        }
      }

      // The lightbox binds its own open trigger on the gallery; we only need to
      // follow it, so the gallery and thumbnails match whatever it last showed.
      // See assets/product-lightbox.js.
      var lightbox = productRoot.querySelector('product-lightbox');
      if (lightbox) {
        lightbox.addEventListener('lightbox:change', function (e) {
          if (e.detail && e.detail.mediaId) setActiveMedia(e.detail.mediaId);
        });
      }

      if (qtyDecrease && qtyIncrease && qtyInput) {
        qtyDecrease.addEventListener('click', function () {
          var currentValue = parseInt(qtyInput.value, 10);
          var nextValue = Number.isNaN(currentValue) ? 1 : Math.max(1, currentValue - 1);
          qtyInput.value = String(nextValue);
          updateQtyButtons();
        });

        qtyIncrease.addEventListener('click', function () {
          var currentValue = parseInt(qtyInput.value, 10);
          var max = parseInt(qtyInput.getAttribute('max'), 10);
          var nextValue = Number.isNaN(currentValue) ? 1 : currentValue + 1;
          if (!Number.isNaN(max)) nextValue = Math.min(nextValue, max);
          qtyInput.value = String(nextValue);
          updateQtyButtons();
        });

        qtyInput.addEventListener('change', function () {
          var currentValue = parseInt(qtyInput.value, 10);
          var max = parseInt(qtyInput.getAttribute('max'), 10);
          var clamped = Number.isNaN(currentValue) || currentValue < 1 ? 1 : currentValue;
          if (!Number.isNaN(max)) clamped = Math.min(clamped, max);
          qtyInput.value = String(clamped);
          updateQtyButtons();
        });

        updateQtyButtons();
      }

      fetch('/cart.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          cart.items.forEach(function (item) {
            cartQuantities[item.variant_id] = (cartQuantities[item.variant_id] || 0) + item.quantity;
          });
          syncVariantUI(findVariantFromSelections());
          updateOptionAvailability();
        })
        .catch(function () {
          syncVariantUI(findVariantFromSelections());
          updateOptionAvailability();
        });
    }

    var productRoots = document.querySelectorAll('[data-product-page]');
    if (!productRoots.length) return;
    productRoots.forEach(initProductPage);
  })();

  // Move #izyrent (app-injected) between quantity and payment buttons
  (function moveIzyrent() {
    function attemptMove() {
      var izyrent = document.getElementById('izyrent');
      var paymentButtons = document.querySelector('[data-payment-buttons]');
      if (izyrent && paymentButtons && paymentButtons.parentNode) {
        paymentButtons.parentNode.insertBefore(izyrent, paymentButtons);
        return true;
      }
      return false;
    }
    if (!attemptMove()) {
      var observer = new MutationObserver(function () {
        if (attemptMove()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('[data-related-products]');
    if (!section) return;
    var productId = section.dataset.productId;
    var shopifySection = section.closest('.shopify-section');
    var sectionId = shopifySection && shopifySection.id ? shopifySection.id.replace('shopify-section-', '') : null;
    if (!productId || !sectionId) return;
    var limit = section.dataset.limit || 8;

    fetch('/recommendations/products?section_id=' + sectionId + '&product_id=' + productId + '&limit=' + limit)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newSection = doc.querySelector('[data-related-products]');
        if (newSection) section.innerHTML = newSection.innerHTML;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    // Filter panel — collapsible accordion on mobile, always open in the desktop sidebar
    var panel = document.getElementById('filter-panel');
    if (panel) {
      var rootStyles = getComputedStyle(document.documentElement);
      var mdBreakpoint = rootStyles.getPropertyValue('--breakpoint-md').trim() || '48rem';
      var mdMedia = window.matchMedia('(min-width: ' + mdBreakpoint + ')');
      var originalParent = panel.parentElement;
      var originalNextSibling = panel.nextElementSibling;

      function placePanelAfterToolbar() {
        var toolbar = document.querySelector('.filter-toolbar');
        if (toolbar && toolbar.nextElementSibling !== panel) {
          toolbar.insertAdjacentElement('afterend', panel);
        }
      }

      function placePanelInSidebar() {
        if (!originalParent) return;
        if (originalNextSibling && originalNextSibling.parentElement == originalParent) {
          originalParent.insertBefore(panel, originalNextSibling);
        } else {
          originalParent.appendChild(panel);
        }
      }

      function syncResponsiveFilterPanel() {
        if (mdMedia.matches) {
          placePanelInSidebar();
          panel.setAttribute('open', '');
        } else {
          placePanelAfterToolbar();
          panel.removeAttribute('open');
        }
        panel.classList.remove('hidden');
      }

      syncResponsiveFilterPanel();
      mdMedia.addEventListener('change', syncResponsiveFilterPanel);
    }

    // Apply button — disabled until a checkbox or price input changes
    var applyBtn = document.querySelector('#filter-form button[type="submit"]');
    if (applyBtn) {
      applyBtn.disabled = true;
      document.querySelectorAll('.filter-checkbox').forEach(function (cb) {
        cb.addEventListener('change', function () {
          applyBtn.disabled = false;
        });
      });
      document.querySelectorAll('.price-input').forEach(function (inp) {
        inp.addEventListener('input', function () {
          applyBtn.disabled = false;
        });
      });
    }

    // Sort select — update URL preserving q and other params
    var sortSelect = document.getElementById('sort-by');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-event"]) return;
  try {
    
  (function () {
    const link = document.querySelector('[data-event-back]');
    const label = link && link.querySelector('[data-event-back-label]');
    if (link && label && document.referrer) {
      try {
        const ref = new URL(document.referrer);
        if (ref.origin === window.location.origin && ref.pathname === '/pages/calendar-1') {
          link.href = '/pages/calendar-1';
          label.textContent = 'Calendar';
        }
      } catch (e) {}
    }
  })();

  // <share-button> is defined once, in snippets/share-button.liquid — every
  // section and snippet script ships in the same compiled bundle.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trail-index"] && !Shopify.designMode) return;
  try {
    
  class RoutesFilter extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-location-tab]'));
      // Captured in DOM order, so this array doubles as the "Default" sort —
      // never reorder it, sort copies instead.
      this.cards = Array.from(this.querySelectorAll('[data-route-card]'));
      this.emptyEl = this.querySelector('[data-routes-empty]');
      this.grid = this.querySelector('[data-routes-grid]');
      this.sortSelect = this.querySelector('[data-routes-sort]');
      this.ranges = {};
      this.activeLocation = this.tabs.length ? this.tabs[0].dataset.locationTab : '';
      this.sortValue = this.sortSelect ? this.sortSelect.value : 'default';

      this.querySelectorAll('.range-slider').forEach((slider) => this.initSlider(slider));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          this.activeLocation = tab.dataset.locationTab;
          this.tabs.forEach((t) => {
            const active = t === tab;
            t.classList.toggle('trail-tab--active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          this.applyFilters();
        });
      });

      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', () => {
          this.sortValue = this.sortSelect.value;
          this.applySort();
        });
      }

      this.applyFilters();
      // Runs last so a browser-restored selection (back-nav / bfcache) is honoured.
      this.applySort();
    }

    initSlider(slider) {
      const id = slider.dataset.range;
      const lo = Number(slider.dataset.min);
      const hi = Number(slider.dataset.max);
      const span = hi - lo || 1;
      const minInput = slider.querySelector('[data-range-min]');
      const maxInput = slider.querySelector('[data-range-max]');
      const fill = slider.querySelector('[data-range-fill]');
      const minLabel = slider.querySelector('[data-range-min-label]');
      const maxLabel = slider.querySelector('[data-range-max-label]');

      this.ranges[id] = { min: lo, max: hi };

      const update = (source) => {
        let a = Number(minInput.value);
        let b = Number(maxInput.value);
        if (a > b) {
          if (source === 'min') {
            a = b;
            minInput.value = a;
          } else {
            b = a;
            maxInput.value = b;
          }
        }
        this.ranges[id] = { min: a, max: b };
        if (minLabel) minLabel.textContent = a;
        if (maxLabel) maxLabel.textContent = b;
        if (fill) {
          // Percentages of .range-slider__rails, which is already inset by half
          // a thumb — so 0% and 100% land on the thumb centres at min/max.
          fill.style.left = ((a - lo) / span) * 100 + '%';
          fill.style.width = ((b - a) / span) * 100 + '%';
        }
        this.applyFilters();
      };

      minInput.addEventListener('input', () => update('min'));
      maxInput.addEventListener('input', () => update('max'));
      update('init');
    }

    applyFilters() {
      let visible = 0;
      this.cards.forEach((card) => {
        let show = card.dataset.location === this.activeLocation;
        if (show) {
          const checks = [
            ['distance', Number(card.dataset.distance)],
            ['elevation', Number(card.dataset.elevation)],
            ['difficulty', Number(card.dataset.difficulty)],
          ];
          for (const [key, value] of checks) {
            const r = this.ranges[key];
            if (r && (value < r.min || value > r.max)) {
              show = false;
              break;
            }
          }
        }
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (this.emptyEl) this.emptyEl.hidden = visible !== 0;
    }

    /* Reorders the cards in place. Independent of applyFilters — sorting never
       changes visibility, filtering never changes order, so each card keeps its
       own `hidden` state through the move. Blank values arrive as data-* = 0,
       matching how the sliders treat them, so they lead asc and trail desc. */
    applySort() {
      if (!this.grid) return;

      const [key, dir] = this.sortValue.split('-');
      let ordered = this.cards;

      if (key && key !== 'default') {
        const sign = dir === 'desc' ? -1 : 1;
        ordered = this.cards.slice().sort((a, b) => {
          const byName = this.compareNames(a, b);
          if (key === 'name') return sign * byName;
          // Ties fall back to A–Z in both directions.
          return sign * (Number(a.dataset[key]) - Number(b.dataset[key])) || byName;
        });
      }

      const fragment = document.createDocumentFragment();
      ordered.forEach((card) => fragment.appendChild(card));
      this.grid.appendChild(fragment);
    }

    compareNames(a, b) {
      return (a.dataset.name || '').localeCompare(b.dataset.name || '', undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    }
  }

  if (!customElements.get('routes-filter')) {
    customElements.define('routes-filter', RoutesFilter);
  }

  } catch(e) { console.error(e); }
})();
})();
